/* REDUX ACTION TYPES */
export const APP_SET_LOADING = "[APP] SET_LOADING"